import React from "react";

const LoginHeader = () => {
  return (
    <div className="mb-8">
      <h2 className="text-[28px] font-bold leading-tight tracking-tight heading-gradient-flag">
        Welcome back
      </h2>
      <p className="mt-2 text-sm leading-relaxed text-[#5a6b8a]">
        Sign in to manage leads, campaigns, and pipeline performance from a
        single dashboard.
      </p>
    </div>
  );
};

export default LoginHeader;
